import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@mui/material";
import { t } from "i18next";
import Information from "./Information";
import {
  IFrontLayerInformationPage,
  IFrontlayerConfigValues,
  IFrontlayerConfiguration,
} from "../../../../../../../types/NendaTypes";

interface InformationPageConfigProps {
  state: IFrontLayerInformationPage;
  handleChange: (mutatedState: IFrontLayerInformationPage) => void;
  upload: (file: File, imageCategory: string) => void;
  config: IFrontlayerConfigValues; // Add this prop
}

const InformationPageConfig: React.FC<InformationPageConfigProps> = ({
  state,
  handleChange,
  upload,
  config,
}: InformationPageConfigProps) => {
  const informationPageBackgroundUpload = (file: File) => {
    upload(file, "informationPageBackground");
  };

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {t("customerportal.settings.premise_settings.frontlayer.information")}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          width: "100%",
          gap: "2rem",
        }}
      >
        <Box>
          <Information
            config={state}
            onConfigChange={handleChange}
            onUpload={informationPageBackgroundUpload}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default InformationPageConfig;
